<template>
  <div>
    <GiantTree :nodes="treeData" @onCreated="onTreeCreated" @onClick="onTreeNodeClick" /></div>
</template>

<script>
export default {
    components: {

    },
    props: {

    },
    data() {
        return {
            zTree: {},
            treeData: [],
            treeNode: {},
            loginUser: this.$store.getters.loginUser,
            folderUser: '/plugins/zTree/css/img/folder_user.png'
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.getTreeData()
    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {
        onTreeCreated(zTree) {
            this.zTree = zTree
        },
        getTreeData() {
            this.$http({
                method: 'POST',
                url: 'portal/cms/articleCate/querydata',
                contentType: 'application/x-www-form-urlencoded',
                data: [{
                    'compare': '=',
                    'field': 'status',
                    'merge': true,
                    'value': 1
                }, { compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                params: { 'orderBy': 'orderNo asc' }
            }).then(res => {
                if (res.code === 'success') {
                    this.treeData = this.initTreeData(res.body.listdata)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        initTreeData(treedata) {
            treedata.unshift({ id: '0', name: '新闻中心', parentId: '', orderNo: '' })
            treedata.forEach(node => {
                node.pId = node.parentId
                node.title = node.name + ' ' + node.orderNo
                if (node.id === '0') {
                    node.checked = true
                    node.open = true
                }
            })
            return treedata
        },
        onTreeNodeClick(evt, treeId, treeNode) {
            this.$nextTick(() => {
                this.$bus.emit('treeClick', treeNode)
            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>
